export const classes = {
  tabContainer: { margin: "2% 4%" },
};
